<template>
<div>
    <user-information v-if="showOnboardingOnly" />
    <add-Property v-else />
</div>
</template>

<script>
import addProperty from './add_property.vue';
import userInformation from '../guest/user_information.vue';

export default {
    components: {
        addProperty,
        userInformation,
    },
    computed: {
        showOnboardingOnly() {
            const from = this.$route.query.from;
            return this.$route.query.setup === 'stripe'
                || from === 'booking_requests'
                || from === 'dashboard'
                || from === 'custom_offers';
        },
    },
};
</script>
